<div class="row">
  <new-point [processing]="processing" (toggleCreatePoint)="create($event)" (toggleCancel)="cancel()"></new-point>
</div>
